import React from 'react';
import useElectronicSignature from '../../../Certificates/Hooks/useElectronicSignature';
import Loading from '../../../../Components/Loading';
import { Theme } from '../../../../Enums/Theme.enum';
import LinkButton from '../../../../Components/Button/LinkButton';
import Tooltip from '../../../../Components/Popup/Tooltip';
import Text from '../../../../Components/Base/Text/Text';
import ElectronicSignatureUnavailableTooltip from '../ElectronicSignature/ElectronicSignatureUnavailableTooltip';

interface Props {
	isSignAllowed: boolean;
	onClick: () => void;
}

const SignButton: React.FC<Props> = ({ isSignAllowed, onClick }) => {
	const { isQualifiedCertificateForElectronicSignatureUsed, isLoading } =
		useElectronicSignature();

	if (isLoading) {
		return <Loading />;
	}

	const Button: React.ReactNode = (
		<LinkButton
			title='base.doElectronicSignature'
			theme={Theme.BLUE}
			firstUpper
			onClick={onClick}
			disabled={
				!isQualifiedCertificateForElectronicSignatureUsed || !isSignAllowed
			}
		/>
	);

	if (!isQualifiedCertificateForElectronicSignatureUsed) {
		return <ElectronicSignatureUnavailableTooltip trigger={Button} />;
	}

	if (!isSignAllowed) {
		return (
			<Tooltip trigger={Button}>
				<Text tx='component.signButton.signNotAllowed' />
			</Tooltip>
		);
	}

	return Button;
};

export default SignButton;
